import type { OntologyField } from 'features/libra/ontology/ontologyFieldTypes'

export const fieldLabelsForIds = (
  fieldIds: string[],
  ontologyFields: Record<string, OntologyField>
): Record<string, string> =>
  Object.fromEntries(fieldIds.map((id) => [id, ontologyFields[id]?.name ?? id]))
